@if ({
  reqReports: reqReports$ | async,
  currentReport: currentReport$ | async,
  }; as content) {
  <div class="reports">
    <div class="simple-card">
      <page-title></page-title>
    </div>
    <div class="simple-card m-t-20">
      @if (!content.reqReports?.isPristine) {
        @if (!content.reqReports?.isLoading) {
          @if (!content.reqReports?.hasError) {
            @if (content.reqReports?.reports?.length) {
              @if (content.currentReport) {
                <tab-options [options]="content?.reqReports?.reports || []" [(currentOption)]="content.currentReport"></tab-options>
                @if (content.currentReport.code === REPORTS.PRICING_STATUS) {
                  <pricing-status></pricing-status>
                }
                @if (content.currentReport.code === REPORTS.PURCHASE_SUMMARY) {
                  <purchase-summary></purchase-summary>
                }
                @if (content.currentReport.code === REPORTS.CREDIT_SUMMARY) {
                  <credit-summary></credit-summary>
                }
                @if (content.currentReport.code === REPORTS.PAYMENT_HISTORY) {
                  <payment-history></payment-history>
                }
              }
            } @else {
              <p class="text-center ff-bold m-0">{{ 'reports.noContent' | cxTranslate }}</p>
            }
          } @else {
            <alert [alert]="alertMessage"></alert>
          }
        } @else {
          <local-loader></local-loader>
        }
      }
    </div>
  </div>
}